/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-aviso-cpf-invalido__subtitle[_ngcontent-%COMP%]{padding:10px 0 0;color:#717171}.modal-aviso-cpf-invalido__body[_ngcontent-%COMP%]{padding:15px 45px 0}.modal-aviso-cpf-invalido__content[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding:1em}.modal-aviso-cpf-invalido__action[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;border:0}"];
export { styles as styles };
